const PRODUCT_TYPES_MAPPING = {
  interlayer_variants: 'interlayer_variants',
  graphic_pattern_variants: 'graphic_pattern_variants',
  colors: 'colors',
};

let requestSampleButton,
  requestInfoButton,
  sampleTypesSelect,
  accountLinks,
  accountLinksToggle;

export const findSampleTypesSelect = () => {
  if (sampleTypesSelect) return sampleTypesSelect;

  sampleTypesSelect = document.querySelector('.js-sample-types-select');

  return sampleTypesSelect;
};

export const isProductAvailable = () => {
  return (
    (findSampleTypesSelect() && !noExistingProducts()) ||
    (findRequestSampleButton() &&
      !!requestSampleButton.getAttribute('data-product-id'))
  );
};

const findRequestSampleButton = () =>
  (requestSampleButton =
    requestSampleButton || document.querySelector('[data-add-to-cart="true"]'));

const findRequestInfoButton = () =>
  (requestInfoButton =
    requestInfoButton || document.querySelector('[data-request-info="true"]'));

export const updateCartIndicator = itemCount => {
  const cartIndicators = document.querySelectorAll('.cart-indicator');

  if (itemCount > 0) {
    cartIndicators.forEach(indicator => {
      const cartIconCount = indicator.querySelector('.icon-cart-count');

      if (cartIconCount) {
        if (cartIconCount.classList.contains('hidden'))
          cartIconCount.classList.remove('hidden');

        cartIconCount.innerText = itemCount;
      }
    });
  }
};

export const getProductsProperties = () => {
  const sampleTypesSelect = findSampleTypesSelect();

  if (!sampleTypesSelect) return [getProductPropertiesFromButton()];

  let productsProperties = [];
  Object.values(sampleTypesSelect.options).forEach(sampleTypeOption => {
    productsProperties.push({
      type: PRODUCT_TYPES_MAPPING[sampleTypeOption.dataset.productType],
      id: sampleTypeOption.dataset.productId,
      sampleTypeId: sampleTypeOption.value,
    });
  });

  return productsProperties;
};

const getProductPropertiesFromButton = () => {
  const button = findRequestSampleButton();

  if (!button) return;

  return {
    id: button.dataset.productId,
    analyticsTracker: button.dataset.analyticsTracker,
    cartModalInfo: {
      sampleType: button.dataset.sampleTypeText,
      imgSrc: button.dataset.imgSrc,
    },
  };
};

export const getSelectedSampleTypeProperties = () => {
  if (!findSampleTypesSelect()) return getProductPropertiesFromButton();

  const selectedOption = findSampleTypesSelect().options[
    sampleTypesSelect.selectedIndex
  ];

  return {
    type: PRODUCT_TYPES_MAPPING[selectedOption.dataset.productType],
    id: selectedOption.dataset.productId,
    cartModalInfo: {
      sampleType: selectedOption.dataset.sampleTypeText,
      imgSrc: selectedOption.dataset.imgSrc,
    },
  };
};

export const handleSampleTypesSelectChange = onChange => {
  findSampleTypesSelect().addEventListener('change', onChange);
};

let workingRequest = 0;
export const handleRequestSampleButtonClick = onClick => {
  findRequestSampleButton().dataset.requestId = workingRequest;

  findRequestSampleButton().addEventListener('click', async event => {
    if (Number(event.target.dataset.requestId) < workingRequest) return;

    workingRequest++;

    document.activeElement.blur();

    await onClick(event);

    event.target.dataset.requestId = workingRequest;
  });
};

export const handleNotExistingProduct = sampleTypeId => {
  if (!sampleTypeId) {
    findRequestSampleButton().setAttribute('data-product-id', null);
    return;
  }

  findSampleTypesSelect();

  const option = sampleTypesSelect.querySelector(
    `option[value="${sampleTypeId}"]`
  );

  if (option) sampleTypesSelect.removeChild(option);
};

const noExistingProducts = () => findSampleTypesSelect().options.length <= 0;

export const handleNoExistingProducts = () => {
  hideSampleTypesSelect();
  hideRequestSampleButton();
  showRequestInfoButton();
};

export const enableRequestSampleButton = productId => {
  const button = findRequestSampleButton();

  if (button) {
    if (typeof productId !== 'undefined') {
      button.setAttribute('data-product-id', productId);
    }

    button.disabled = false;
  }
};

export const disableRequestSampleButton = () => {
  const button = findRequestSampleButton();

  if (button) {
    button.disabled = true;
  }
};

const toggleSampleTypesSelect = booleanSwitch => {
  return () => {
    findSampleTypesSelect();

    if (!sampleTypesSelect) return;

    const method = booleanSwitch ? 'remove' : 'add';
    sampleTypesSelect.parentNode.classList[method]('hidden');
  };
};
export const showSampleTypesSelect = toggleSampleTypesSelect(true);
export const hideSampleTypesSelect = toggleSampleTypesSelect(false);

const toggleButton = button => {
  return booleanSwitch => {
    return () => {
      if (!button) return;

      const method = booleanSwitch ? 'remove' : 'add';

      button.classList[method]('hidden');
      button.disabled = !booleanSwitch;
    };
  };
};
const toggleRequestSampleButton = toggleButton(findRequestSampleButton());
export const showRequestSampleButton = toggleRequestSampleButton(true);
export const hideRequestSampleButton = toggleRequestSampleButton(false);

const toggleRequestInfoButton = toggleButton(findRequestInfoButton());
export const showRequestInfoButton = toggleRequestInfoButton(true);
export const hideRequestInfoButton = toggleRequestInfoButton(false);

const convertSizeString = string => {
  const regex = /(\d+)(x|X)(\d+(\.\d+)?)/g;
  const result = '$1\u2033 $2 $3\u2033';
  return string.replace(regex, result);
};

export const changeProductSizeInfoInModal = (size, type, lineBreak = false) => {
  if (size !== null && size !== '') {
    const modalSizeElement = document.querySelector('#sample-size-info'),
      sizeParagraph = document.createElement('p'),
      sizeText = convertSizeString(size);

    sizeParagraph.innerHTML = `${sizeText}${lineBreak ? '<br />' : ' '}${type}`;

    if (modalSizeElement) {
      modalSizeElement.innerHTML = '';
      modalSizeElement.appendChild(sizeParagraph);
    }
  }
};

export const changeProductImageInModal = imgSrc => {
  if (!!imgSrc) {
    const modalImageElement = document.querySelector(
      '.js-request-sample-image'
    );
    if (modalImageElement) modalImageElement.setAttribute('src', imgSrc);
  }
};

export const getSampleRequestModal = () =>
  document.querySelector('#modal-request-sample');

export const changeProductNameInModal = (title, subtitle) => {
  const modal = getSampleRequestModal(),
    titleElement = modal.querySelector('.js-request-sample-title'),
    subtitleElement = modal.querySelector('.js-request-sample-subtitle');

  titleElement.innerText = title;
  subtitleElement.innerText = subtitle || '';
};

const handleOutsideModalClick = event => {
  const modal = getSampleRequestModal();
  var target = event.target;

  do {
    if (target === modal) {
      return;
    }
    target = target.parentNode;
  } while (target);

  MicroModal.close('modal-request-sample');
};

const setRequestSampleModalListener = element => {
  element.addEventListener('click', handleOutsideModalClick);
};

export const setupRequestSampleModal = () => {
  setRequestSampleModalListener(window.document);
  setRequestSampleModalListener(document.querySelector('#js-global-nav'));
};

let requestSampleModal;
export const findRequestSampleModal = () => {
  if (requestSampleModal) return requestSampleModal;

  return (requestSampleModal = document.querySelector('#modal-request-sample'));
};

// This relies on checking the number of options in the select, of which one is
// removed if its value is blank or undefined so this can be unreliable if
// it's called at the wrong time.
export const singleSampleType = () => {
  return findSampleTypesSelect().options.length === 1;
};

export const findAccountLinksToggle = () => {
  if (accountLinksToggle) return accountLinksToggle;

  accountLinksToggle = document.querySelector('.js-account-links-toggle');

  return accountLinksToggle;
};

const findAccountLinks = () => {
  if (accountLinks) return accountLinks;

  accountLinks = document.querySelector('.js-account-links');

  return accountLinks;
};

export const toggleAccountLinks = () => {
  findAccountLinks().classList.toggle('show');
};

const fixAccountLinksDomain = () => {
  findAccountLinks()
    .querySelectorAll('a')
    .forEach(a => {
      a.setAttribute(
        'href',
        `${window.SpreeAPI.host}${a.getAttribute('href')}`
      );
    });
};

const handleOutsideAccountLinksClick = event => {
  findAccountLinks();
  findAccountLinksToggle();

  var target = event.target;

  do {
    if (target === accountLinks || target === accountLinksToggle) {
      return;
    }
    target = target.parentNode;
  } while (target);

  accountLinks.classList.remove('show');
};

const setAccountLinksListener = element => {
  element.addEventListener('click', handleOutsideAccountLinksClick);
};

export const setupAccountLinks = () => {
  fixAccountLinksDomain();
  setAccountLinksListener(window.document);
};
